import React from "react";
import {RichText} from "prismic-reactjs";
import {get} from "lodash";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {useTheme} from "@material-ui/core/styles";

export default function InfoBoxSlice(slice) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("768"));
  const backgroundImage = get(slice, "primary.background_image.url");

  const backgroundStyle = {
    backgroundImage: `url("${backgroundImage}")`,
  };

  const renderInfoBoxes = slice.items.map((el, i) => {
    return (
      <div className="box-wrapper" key={i}>
        <div className="box">
          <RichText render={get(el, "headline")} />
        </div>
        <div className="copy">
          <RichText render={get(el, "copy")} />
        </div>
      </div>
    );
  });

  return (
    <section className="info-box-slice" style={backgroundStyle}>
      <div className="wrapper">
        <div className="content">
          <RichText render={get(slice, "primary.copy")} />
        </div>
        <div className="info-boxes">{renderInfoBoxes}</div>
      </div>
    </section>
  );
}
